export default __webpack_public_path__ + "static/838-c75be2265200c6e3fffae630cd8e894c.gif";